import { Text } from '@risksmart-app/atomic-ui';

import type { RatingRowData } from '../types';
import { RatingBadge } from './RatingBadge';

interface RatingRowProps {
  data: RatingRowData;
  datePrefix: string;
  notRatedLabel: string;
  noRatingScoreLabel: string;
  noRatingAvailableLabel: string;
}

const RatingRow = ({
  data,
  datePrefix,
  notRatedLabel,
  noRatingScoreLabel,
  noRatingAvailableLabel,
}: RatingRowProps) => {
  const { label, rating, formattedDate } = data;
  const hasRating = rating !== undefined;

  return (
    <div
      className={'rounded-md bg-neutral-minimal p-2.5 flex flex-col gap-1.5'}
    >
      <Text preset={'body-sm'} className={'font-semibold text-primary-hover'}>
        {label}
      </Text>
      {hasRating ? (
        <RatingBadge
          rating={rating}
          notRatedLabel={notRatedLabel}
          className={'justify-center px-3 py-2 text-sm font-semibold'}
        />
      ) : (
        <span
          className={
            'inline-flex items-center justify-center rounded-sm bg-muted text-muted-foreground px-3 py-2 text-sm font-semibold'
          }
          data-testid={'rating-row-no-rating'}
        >
          {noRatingScoreLabel}
        </span>
      )}
      <Text
        preset={'body-sm'}
        className={'text-muted-foreground text-xs'}
        data-testid={'rating-row-date'}
      >
        {hasRating
          ? `${datePrefix} ${formattedDate ?? '-'}`
          : noRatingAvailableLabel}
      </Text>
    </div>
  );
};

export { RatingRow };
